/* eslint-disable formatjs/no-literal-string-in-jsx */
import { Theme, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

interface Props {
  copy: string;
  linkCopy: string;
}

const ImportHelp = ({ copy, linkCopy }: Props) => {
  const classes = useStyles();

  return (
    <div>
      <Typography className={classes.copy} component="p" variant="caption">
        {copy}
        {": "}
        <a
          className={classes.link}
          href="https://help.cleverfarm.ag/cs/articles/12040393-jak-vytvorim-svoji-farmu"
          rel="noopener noreferrer"
          target="_blank"
        >
          {linkCopy}
        </a>
      </Typography>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  dialogTitle: {
    fontSize: 21,
    fontWeight: 500,
  },
  copy: {
    color: theme.palette.grey[500],
  },
  link: {
    color: theme.palette.primary.main,
  },
}));

export { ImportHelp };
